import { Controller } from "@hotwired/stimulus"
import { TurboNativeBridge } from "../turbo_native_bridge"

// Adds a paste button inside text inputs/textareas that works on both
// mobile web (Clipboard API) and iOS native app (native bridge).
export default class extends Controller {
  static targets = ["input"]
  static values = {
    label: { type: String, default: "Paste" },
    hideAfterPaste: { type: Boolean, default: false }
  }

  connect() {
    this.button = document.createElement("button")
    this.button.type = "button"
    this.button.className = "input-with-paste__btn"
    this.button.textContent = this.labelValue
    this.button.addEventListener("click", this.paste)

    this.element.classList.add("input-with-paste")
    if (this.inputTarget.tagName === "TEXTAREA") {
      this.element.classList.add("input-with-paste--textarea")
    }
    this.inputTarget.after(this.button)
  }

  paste = async (event) => {
    event.preventDefault()
    const text = await this.getClipboardText()

    if (text) {
      this.inputTarget.value = text
      this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
      this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
      this.inputTarget.focus()

      if (this.hideAfterPasteValue) {
        this.button.hidden = true
      }
    }
  }

  async getClipboardText() {
    if (TurboNativeBridge.isNative) {
      const text = await TurboNativeBridge.getClipboardText()
      if (text) return text
    }

    if (navigator.clipboard?.readText) {
      try {
        return await navigator.clipboard.readText()
      } catch {
        // Clipboard API failed (permissions, not focused, etc.)
      }
    }

    return null
  }
}
